import { RoleObjectType } from '@/interfaces/roleObjectType';
import { RoleResource, roleResource } from '@/resources/role.resource';
import store from '@/store/store';
import { EntityModule } from '../entity.module';

/**
 * Role przypisane do użytkownika
 *
 * @export
 * @class UserRolesModule
 * @extends {EntityModule<RoleObjectType, RoleResource>}
 */
export class UserRolesModule extends EntityModule<RoleObjectType, RoleResource> {
  constructor() {
    super(roleResource);
    this.actions = {
      ...this.actions,
      /**
       * Lista ról użytkownika
       *
       * @param context context
       */
      list: async (context: any): Promise<void> => {
        const list = await this.resource.userRoles(context.rootState.profile.id);
        context.commit('saveList', list);
      },
      /**
       * Usuwa rolę użytkownikowi
       *
       * @param context context
       * @param roleId id roli
       */
      remove: async (context: any, roleId: number): Promise<void> => {
        await this.resource.userRoleDelete(roleId, context.rootState.profile.id);
        store.dispatch('profile/roles/list', context.rootState.profile.id);
      },
      /**
       * Dodaje rolę do użytkownika
       *
       * @param context context
       * @param roleId id roli
       */
      add: async (context: any, roleId: number): Promise<void> => {
        await this.resource.userRoleAdd(roleId, context.rootState.profile.id);
        store.dispatch('profile/roles/list', context.rootState.profile.id);
      }
    };
  }
}

export default new UserRolesModule();
